import Banner from "./banner";
import Community from "./community";
import Make from "./make";
import Questions from "./questions";
import Social from "./sip";
import Works from "./works";
const Home = () => {
  return (
    <div className="container-fluid">
      <Banner></Banner>
      <Community></Community>
      <Social></Social>
      <Works></Works>
      <Questions></Questions>
      <Make></Make>
    </div>
  );
};
export default Home;
